import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { PortalPage, Spinner } from "@/components/PortalPage";
import { api } from "@/lib/api";
import { openAgreementPdf } from "@/components/agreements/agreementApi";

const ROWS = [["start_date", "Start date"], ["term_years", "Term", (v) => `${v} years`], ["renewal_date", "Renewal date"], ["territory", "Territory"],
  ["royalty_percent", "Royalty", (v) => `${v}%`], ["marketing_percent", "Marketing fund", (v) => `${v}%`], ["tech_fee_usd", "Technology fee", (v) => `$${v} / month`],
  ["insurance_requirements", "Insurance requirements"], ["other_requirements", "Other requirements"]];

export default function MyAgreement() {
  const [d, setD] = useState(null);
  useEffect(() => { api("/agreements/mine").then(setD).catch(() => setD({ has_agreement: false })); }, []);
  return (
    <PortalPage eyebrow="MY FRANCHISE" title="My Franchise Agreement" testId="my-agreement-page" width="max-w-3xl">
      {!d ? <Spinner /> : !d.has_agreement ? (
        <p data-testid="my-agreement-none" className="text-sm text-neutral-400">Your signed agreement hasn't been added yet. ALR Corporate will upload it for you.</p>
      ) : (
        <>
          <button data-testid="my-agreement-open" onClick={() => openAgreementPdf("mine/file", d.filename).catch((e) => toast.error(e.message))} className="flex w-fit items-center gap-2 rounded-[10px] bg-[#4CCC06] px-4 py-2.5 text-sm font-extrabold text-black"><FileText size={16} />View / download {d.filename}</button>
          {d.confirmed && (
            <div className="divide-y divide-[#2a2a2a] rounded-xl border border-[#333] bg-[#1A1A1A]" data-testid="my-agreement-terms">
              {ROWS.filter(([k]) => d.terms[k] != null && d.terms[k] !== "").map(([k, l, f]) => (
                <div key={k} className="flex gap-4 px-4 py-3 text-sm"><span className="w-40 shrink-0 text-neutral-400">{l}</span><span className="text-white" data-testid={`my-agreement-${k}`}>{f ? f(d.terms[k]) : d.terms[k]}</span></div>
              ))}
            </div>
          )}
          <p className="text-xs text-neutral-500">This summary is for convenience. Your signed agreement is the official document.</p>
        </>
      )}
    </PortalPage>
  );
}
